import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Divider,
  Typography,
} from '@material-ui/core';
import moment from 'moment';
import firebase from '../../../../config/config';
import apiCaller from '../../../../utils/apiCallerOutstanding';
import { mappedCurrentActiveRole } from '../../../../utils/roleMapping';

const useStyles = makeStyles({
  root: {
    minWidth: 275,
    marginTop: '30px',
    textAlign: 'left',
    marginBottom: 10,
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 2,
  },
  cardSection: {
    marginBottom: '10px',
  },
  sectionContent: {
    padding: '0 10px',
  },
  commentBox: {
    display: 'flex',
    alignItems: 'flex-end',
    marginBottom: '10px',
  },
  commentAvatar: {
    display: 'inline-block',
    width: '36px',
    height: '36px',
    borderRadius: '50%',
    backgroundColor: '#C2185B',
    textAlign: 'center',
    flexShrink: 0,
    lineHeight: '36px',
    marginBottom: '20px',
  },
  commentText: {
    marginLeft: '10px',
    backgroundColor: '#EFF6FC',
    borderRadius: '4px',
    padding: '5px',
  },
  noComments: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    padding: '10px',
  },
  rajdhaniFont: {
    fontFamily: 'Rajdhani',
    margin: 0,
  },
});

export default function OutlinedCard({ transactionId, activeRole }) {
  const [commentsData, setCommentsData] = useState([]);
  const [fetching, setFetching] = useState(false);
  const classes = useStyles();

  const getComments = async token => {
    setFetching(true);
    const currentActiveRole = mappedCurrentActiveRole(activeRole);
    const endPoint = `trips/get-comments?role=${currentActiveRole}&channel_id=${transactionId}&type=customer_support_transaction`;

    await apiCaller(endPoint, {}, `Bearer ${token}`, 'nh-base', 'get')
      .then(response => {
        setCommentsData(response?.data?.Data);
        setFetching(false);
      })
      .catch(error => setFetching(false));
  };

  useEffect(() => {
    const userDetails = firebase.auth().currentUser;
    const { Aa } = userDetails;
    getComments(Aa);
  }, [transactionId, activeRole]);

  const renderComments = comments => (
    <div>
      {comments.map((commentDetail, index) => (
        <div key={index} className={classes.commentBox}>
          <div className={classes.commentAvatar}>
            <Typography style={{ color: 'white', lineHeight: '36px' }}>
              {commentDetail?.commented_by_name
                ? commentDetail?.commented_by_name?.charAt(0)
                : ''}
            </Typography>
          </div>
          <div className={classes.commentText}>
            <Typography className={classes.pos}>
              {commentDetail?.comment}
            </Typography>
            <Typography
              variant="caption"
              display="block"
              gutterBottom
              color="textSecondary"
            >
              {commentDetail?.commented_by_name}
              {commentDetail?.commented_by_name ? (
                <>&nbsp; &nbsp; &nbsp;</>
              ) : null}
              {moment(commentDetail?.created_at).format('DD-MM-YYYY')}
              &nbsp;
              {moment(commentDetail?.created_at).format('hh:mm A')}
            </Typography>
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <Card className={classes.root}>
      <CardHeader
        title={<p className={classes.rajdhaniFont}>Comments (Escalation)</p>}
      />
      <Divider />
      {fetching ? (
        <CircularProgress size={20} />
      ) : (
        <CardContent>
          {commentsData?.length > 0 && (
            <div className={classes.cardSection}>
              <div className={classes.sectionContent}>
                {renderComments(commentsData)}
              </div>
            </div>
          )}

          {commentsData?.length === 0 && (
            <div className={classes.noComments}>
              <Typography
                className={classes.title}
                color="textSecondary"
                gutterBottom
              >
                No Comments Available
              </Typography>
            </div>
          )}
        </CardContent>
      )}
    </Card>
  );
}
